<template>
    <el-collapse v-model="activeName" accordion>

      <div v-for="(formName, i) in data" :key="i">
        <div v-for="(formvalue, i) in formName.assigned_package_form" :key="i" @click="getForms(formvalue.id)">
          <el-collapse-item  :title="formvalue.title" :name="i">
            <div v-for="(form, doc) in forms" :key="doc">
              <a href="#" @click.prevent="openmodal(form.id)">
                {{form.name}}
              </a>
            </div>
          </el-collapse-item>
        </div>
      </div>
      <task-forms-view-modal
      v-if="isFormModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :id="formId"
      @close-modal="closeFormModal"
    />
    </el-collapse>
</template>

<script>
import {GET_PACKAGE_FORM} from "../../../../Config/ApiUrl";
import {axiosGet} from "../../../../Helpers/AxiosHelper";
  export default {
      props:{data:Array},
    data() {
      return {
        isFormModalActive:false,
        activeName: '1',
        forms:[],
        formId:0,
      };
    },
    methods: {
      openmodal(id) {
        this.isFormModalActive = true;
        this.formId = id;
      },
      closeFormModal() {
        $("#form-view-Modal").modal("hide");
        this.isFormModalActive = false;
      },
      getForms(id) {
        axiosGet(GET_PACKAGE_FORM+'/'+id)
        .then((res) => {
          this.forms = res.data[0].task_forms;
          // this.documentUser = res.data.attachdocumentuser;
          
        })
        .catch((error) => {
          
        });
      },

    }
  }
</script>